module.exports = __webpack_public_path__ + "img/pr-3.14722e6a.png";